import { Injectable } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "primeng/api";
import * as i2 from "@ngx-translate/core";
export class MessageCustomService {
    constructor(messageService, translateService) {
        this.messageService = messageService;
        this.translateService = translateService;
        this.SUCCESS = "success";
        this.ERROR = "error";
        this.WARN = "warn";
        this.INFO = "info";
    }
    successMessage(content) {
        this.messageService.add({ severity: this.SUCCESS, summary: this.translateService.instant("MESSAGES.TITLE.SUCCESS"), detail: content });
    }
    errorMessage(content) {
        this.messageService.add({ severity: this.ERROR, summary: this.translateService.instant("MESSAGES.TITLE.ERROR"), detail: content });
    }
    warnMessage(content) {
        this.messageService.add({ severity: this.WARN, summary: this.translateService.instant("MESSAGES.TITLE.WARN"), detail: content });
    }
    infoMessage(content) {
        this.messageService.add({ severity: this.INFO, summary: this.translateService.instant("MESSAGES.TITLE.INFO"), detail: content });
    }
    personalizedMessage(severity, title, content, durationTimeInMiliseconds, closable) {
        this.messageService.add({ severity: severity, summary: title, detail: content, life: durationTimeInMiliseconds, closable: closable });
    }
    clearMessages() {
        this.messageService.clear();
    }
}
MessageCustomService.ɵfac = function MessageCustomService_Factory(t) { return new (t || MessageCustomService)(i0.ɵɵinject(i1.MessageService), i0.ɵɵinject(i2.TranslateService)); };
MessageCustomService.ɵprov = i0.ɵɵdefineInjectable({ token: MessageCustomService, factory: MessageCustomService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(MessageCustomService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.MessageService }, { type: i2.TranslateService }]; }, null); })();
//# sourceMappingURL=message-custom.service.js.map